/**
 * User-friendly crash & error boundary screen for NumixSheet.
 * Replaces blank white screens with an accessible error UI with Retry & Dashboard buttons.
 */

import { el, button } from './dom.js';

export interface ErrorViewOptions {
  title?: string;
  message?: string;
  onRetry?: () => void;
  onDashboard?: () => void;
}

export function createErrorView(options: ErrorViewOptions = {}): HTMLElement {
  const titleText = options.title || 'Workbook load nahi ho paaya';
  const messageText = options.message || 'Ek anapekshit error aa gaya ya workbook load hone me samay lag raha hai. Kripya punah prayas karein.';

  const container = el('div', {
    className: 'ws-error-screen',
    attrs: {
      id: 'numix-error-screen',
      style: `
        position: fixed; inset: 0; z-index: 999999;
        background: #030712; color: #f8fafc;
        display: flex; flex-direction: column; align-items: center; justify-content: center;
        padding: 24px; font-family: Inter, system-ui, -apple-system, sans-serif;
      `,
    },
  });

  const card = el('div', {
    className: 'ws-error-card',
    attrs: {
      style: `
        max-width: 480px; width: 100%;
        background: #0f172a; border: 1px solid rgba(148,163,184,0.18);
        border-radius: 16px; padding: 32px; text-align: center;
        box-shadow: 0 24px 64px rgba(0,0,0,0.6);
        display: flex; flex-direction: column; align-items: center; gap: 16px;
      `,
    },
  });

  const icon = el('div', {
    attrs: {
      style: `
        width: 56px; height: 56px; border-radius: 50%;
        background: rgba(239, 68, 68, 0.12); border: 1px solid rgba(239, 68, 68, 0.28);
        display: flex; align-items: center; justify-content: center;
        color: #f87171; font-size: 24px; font-weight: 700;
      `,
    },
    text: '⚠️',
  });

  const title = el('h2', {
    text: titleText,
    attrs: {
      style: 'margin: 0; font-size: 20px; font-weight: 700; color: #f8fafc; letter-spacing: -0.3px;',
    },
  });

  const description = el('p', {
    text: messageText,
    attrs: {
      style: 'margin: 0; font-size: 14px; line-height: 1.6; color: #94a3b8;',
    },
  });

  const buttonRow = el('div', {
    attrs: {
      style: 'display: flex; gap: 12px; margin-top: 8px; width: 100%; justify-content: center;',
    },
  });

  const retryBtn = button('🔄 Retry', () => {
    if (options.onRetry) {
      options.onRetry();
    } else {
      window.location.reload();
    }
  }, 'btn-retry');
  retryBtn.style.padding = '10px 20px';
  retryBtn.style.borderRadius = '8px';
  retryBtn.style.fontWeight = '600';
  retryBtn.style.cursor = 'pointer';
  retryBtn.style.background = '#0d9488';
  retryBtn.style.color = '#ffffff';
  retryBtn.style.border = 'none';

  const dashboardBtn = button('📊 Back to Dashboard', () => {
    if (options.onDashboard) {
      options.onDashboard();
    } else {
      window.location.search = '?view=home';
      window.location.hash = '';
    }
  }, 'btn-dashboard');
  dashboardBtn.style.padding = '10px 20px';
  dashboardBtn.style.borderRadius = '8px';
  dashboardBtn.style.background = '#1e293b';
  dashboardBtn.style.border = '1px solid #334155';
  dashboardBtn.style.color = '#cbd5e1';
  dashboardBtn.style.fontWeight = '600';
  dashboardBtn.style.cursor = 'pointer';

  buttonRow.append(retryBtn, dashboardBtn);
  card.append(icon, title, description, buttonRow);
  container.appendChild(card);

  return container;
}
